import { jsx as r, jsxs as n } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { faMinus as x, faCheck as g } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as t } from "@fortawesome/react-fontawesome";
import * as i from "@radix-ui/react-checkbox";
import { twMerge as m } from "tailwind-merge";
const w = c(
  ({ className: a, isError: d, checked: e, ...o }, s) => /* @__PURE__ */ r(
    i.Root,
    {
      className: m(
        // default
        "aspect-square h-4 rounded p-0.5",
        // checked state
        "radix-state-indeterminate:bg-blue-500 radix-state-indeterminate:ring-blue-500",
        "radix-state-checked:ring-blue-500 radix-state-checked:bg-blue-500",
        "radix-state-unchecked:bg-white ring-1 ring-gray-300",
        // disabled
        "radix-disabled:ring-gray-300 radix-disabled:!bg-gray-100",
        "radix-disabled:radix-state-checked:!bg-gray-100 radix-disabled:radix-state-checked:ring-gray-300",
        "radix-disabled:radix-state-indeterminate:!bg-gray-100 radix-disabled:radix-state-indeterminate:ring-gray-300",
        // error
        d && "ring-red-500",
        //
        a
      ),
      ref: s,
      checked: e,
      ...o,
      children: /* @__PURE__ */ n(
        f,
        {
          className: "radix-disabled:text-gray-500 flex flex-col items-center justify-center text-white",
          children: [
            e === "indeterminate" && /* @__PURE__ */ r(t, { icon: x, size: "xs" }),
            e === !0 && /* @__PURE__ */ r(t, { icon: g, size: "xs" })
          ]
        }
      )
    }
  )
), b = i.Root, l = i.Indicator, C = b, f = l;
export {
  w as Checkbox,
  l as CheckboxIndicator,
  b as CheckboxRoot,
  f as Indicator,
  C as Root
};
